import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { RouteDeductionDetailsReportTable } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { routeDeductionDetailsReportSchema } from "../routeDeductionDetailsReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';

const screenCode = 'ROUTEDEDUCTIONDETAILSREPORT'

export function RouteDeductionDetailsReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        fromDate: "",
        toDate: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(routeDeductionDetailsReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [total, setTotal] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const inishialColumName = [{
        title: 'Route Name', field: 'collectionPointName', render: rowData => rowData.collectionPointName, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        fromDate: "",
        toDate: "",
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
        checkDisbursement();
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTEDEDUCTIONDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, routeDeductionDetailsReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetRouteDeductionDetailsReport(searchData.operationEntityID, searchData.collectionPointID, searchData.fromDate, searchData.toDate);

        var contentRowNamesArray = [];
        contentRowNamesArray.push("collectionPointName");
        contentRowNamesArray.push("collectionPointCode");
        contentRowNamesArray.push("collectionTypeName");
        contentRowNamesArray.push("numberOfUnits");
        contentRowNamesArray.push("grossAmount");

        var csvHeaders = [
            { label: "Route Name", value: "collectionPointName" },
            { label: "Route Code", value: "collectionPointCode" },
            { label: "Leaf Type", value: "collectionTypeName" },
            { label: "Bag Count", value: "numberOfUnits" },
            { label: "Gross / kg", value: "grossAmount" }
        ];

        var copyOfColumes = inishialColumName;
        var uniqDates = [];
        reportData.forEach(x => {
            uniqDates.push(x.deductionTypeName.split(' ').map(x => x[0]).join(''))
        })

        setSelectedSearchData();
        uniqDates = [...new Set(uniqDates)];

        var formattedResut = formatResult(reportData);

        var copyOfColumes = inishialColumName;
        copyOfColumes.push({
            title: "numberOfUnits", field: "numberOfUnits", render: rowData => parseFloat(rowData.numberOfUnits).toFixed(2)
            , headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'right' }
        });
        copyOfColumes.push({
            title: "grossAmount", field: "grossAmount", render: rowData => parseFloat(rowData.grossAmount).toFixed(2)
            , headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'right' }
        });
        uniqDates.forEach(x => {
            contentRowNamesArray.push(x);
            csvHeaders.push({
                label: x, value: x
            })
            copyOfColumes.push({
                title: x, field: x, render: rowData => !isNaN(rowData[x]) ? parseFloat(rowData[x]).toFixed(2) : rowData[x]
                , headerStyle: {
                    color: '#000000',
                    textAlign: 'center',
                    fontWeight: 'bold'
                }, cellStyle: { textAlign: 'right' }
            });

            formattedResut.result.forEach(y => {

                if (y[x] === undefined || y[x] === "") {
                    y[x] = "-";
                }

            })
        });

        contentRowNamesArray.push("total");
        contentRowNamesArray.push("deductionPercentage");
        csvHeaders.push({ label: "Total Deduction", value: "total" });
        csvHeaders.push({ label: "Deduction Percentage", value: "deductionPercentage" });
        copyOfColumes.push({
            title: "Total", field: "total", render: rowData => parseFloat(rowData.total).toFixed(2)
            , headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'right' }
        });
        copyOfColumes.push({
            title: "deductionPercentage", field: "deductionPercentage", render: rowData => parseFloat(rowData.deductionPercentage).toFixed(2)
            , headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'right' }
        });

        setColumeNames(copyOfColumes);
        setContentRowNames(contentRowNamesArray);
        setReportData(formattedResut.result);
        setCsvHeaders(csvHeaders);
        generateCsvData(formattedResut);
        setIsTableHide(false);
        createDataTable(contentRowNamesArray, ["#totalCrop", "#totalCropPdf"]);

    }


    function generateCsvData(data) {

        var newRecord = {};
        var copyOfRecords = _.cloneDeep(data.result);

        newRecord.weightReadTime = "Total";
        data.totalResult.forEach(x => {
            newRecord[x.name] = x.value
        });

        copyOfRecords.push(newRecord);

        setCsvData(copyOfRecords);
    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        var noUnit = 0;
        var grossTot = 0;
        var deduPercent = 0;
        var totalRow = [];

        data.forEach(x => {
            var deductionTypeName = (x.deductionTypeName.split(' ').map(x => x[0]).join(''));
            console.log(deductionTypeName)
            if (result.length === 0) {
                result.push({
                    collectionPointName: x.collectionPointName,
                    collectionPointCode: x.collectionPointCode,
                    collectionTypeName: x.collectionTypeName.split(' ').map(x => x[0]).join(''),
                    numberOfUnits: x.numberOfUnits,
                    grossAmount: parseFloat(x.grossAmount),
                    [deductionTypeName]: parseFloat(x.defaultValue) === 0 ? "" : parseFloat(x.defaultValue),
                    total: parseFloat(x.defaultValue),
                    deductionPercentage: (parseFloat(x.defaultValue) / parseFloat(x.grossAmount)) * 100
                });
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.defaultValue);
                totalRow.push({ name: x.deductionTypeName, value: parseFloat(x.defaultValue).toFixed(2) });
                noUnit = noUnit + parseInt(x.numberOfUnits);
                grossTot = grossTot + parseFloat(x.grossAmount);
                deduPercent = ((parseFloat(totalOfAllrecords) / parseFloat(grossTot)) * 100);

            } else {
                var duplicateDate = result.find(y => (y.collectionTypeName) === (x.collectionTypeName.split(' ').map(x => x[0]).join(''))
                    && y.collectionPointName === x.collectionPointName);
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.defaultValue);
                noUnit = noUnit + parseInt(x.numberOfUnits);
                grossTot = grossTot + parseFloat(x.grossAmount);
                deduPercent = ((parseFloat(totalOfAllrecords) / parseFloat(grossTot)) * 100);

                var duplicateTotalRowData = totalRow.find(y => y.name === x.deductionTypeName);

                if (duplicateTotalRowData) {
                    duplicateTotalRowData.value = (parseFloat(duplicateTotalRowData.value) + parseFloat(x.defaultValue)).toFixed(2);
                } else {
                    totalRow.push({ name: x.deductionTypeName, value: parseFloat(x.defaultValue).toFixed(2) });
                }

                if (duplicateDate) {
                    duplicateDate[deductionTypeName] = parseFloat(x.defaultValue) === 0 ? "" : parseFloat(x.defaultValue);
                    duplicateDate.total = parseFloat(duplicateDate.total) + parseFloat(x.defaultValue);
                    duplicateDate.numberOfUnits = parseInt(x.numberOfUnits);
                    duplicateDate.grossAmount = parseFloat(x.grossAmount);
                    duplicateDate.deductionPercentage = (parseFloat(duplicateDate.total) / parseFloat(duplicateDate.grossAmount)) * 100;
                } else {
                    result.push({
                        collectionPointName: x.collectionPointName,
                        collectionPointCode: x.collectionPointCode,
                        collectionTypeName: x.collectionTypeName.split(' ').map(x => x[0]).join(''),
                        numberOfUnits: x.numberOfUnits,
                        grossAmount: parseFloat(x.grossAmount),
                        [deductionTypeName]: parseFloat(x.defaultValue) === 0 ? "" : parseFloat(x.defaultValue),
                        total: parseFloat(x.defaultValue),
                        deductionPercentage: (parseFloat(x.defaultValue) / parseFloat(x.grossAmount)) * 100
                    });
                }

            }
        });
        totalRow.push({ name: "grossAmount", value: grossTot.toFixed(2) });
        totalRow.push({ name: "numberOfUnits", value: noUnit });
        totalRow.push({ name: "total", value: totalOfAllrecords.toFixed(2) });
        totalRow.push({ name: "deductionPercentage", value: deduPercent.toFixed(2) });

        console.log(result)
        setAllTotal(totalRow);
        return {
            result: result,
            totalResult: totalRow
        };
    }
    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                order: [[1, "asc"]],
                destroy: x === '#totalCropPdf' ? true : false,
                searching: x === '#totalCropPdf' ? false : true,
                paging: x === '#totalCropPdf' ? false : true,
                scrollX: false,
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var dynamicCountVariable = [];

                        for (var i = 1; i < contentResult.length; ++i) {
                            if (i > 2) {
                                dynamicCountVariable[i] = rows
                                    .data()
                                    .pluck(i)
                                    .reduce(function (a, b) {
                                        var calResult = checkUndifined(a) + checkUndifined(b) * 1
                                        return calResult;
                                    }, 0);
                            }
                        }

                        var rowData = '';

                        for (var i = 1; i < contentResult.length; ++i) {
                            if (i > 2) {
                                if (i === 3) {
                                    rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i] + '</b></td>';
                                }
                                else
                                    rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i].toFixed(2) + '</b></td>';
                            }
                        }


                        return $('<tr/>')
                            .append('<td colspan="3"><b>Total for ' + group + '</b></td>')
                            .append(rowData);
                    },
                    dataSrc: 0
                }
            })
        });
    }

    function checkUndifined(value) {
        if (value === undefined || value === NaN || value === "-") {
            return 0;
        } else {
            return value;
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID],
            fromDate: searchData.fromDate,
            toDate: searchData.toDate
        })
    }

    function checkDisbursement() {
        if (searchData.month === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'Route Deduction Report',
            fileName: 'Route Deduction Report',
            writeOptions: {}
        }
        var newRow = {
            collectionPointName: "Factory : " + selectedSearchValues.estate,
            collectionPointCode: "From Date : " + selectedSearchValues.fromDate,
            collectionTypeName: "to Date : " + selectedSearchValues.toDate,
            numberOfUnits: "Generated date/time : " + new Date().toLocaleString(),
            grossAmount: "Generated User : " + tokenService.getUserNameFromToken()
        }
        var copyOfCsv = _.cloneDeep(csvData)
        copyOfCsv.push({}, {}, newRow)

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Route Deduction Details Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md">
                                    <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="fromDate"
                                        name="fromDate"
                                        type="date"
                                        value={searchData.fromDate}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                </div>
                                <div className="col-md">
                                    <InputLabel shrink id="toDate">To Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="toDate"
                                        name="toDate"
                                        type="date"
                                        value={searchData.toDate}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {isTableHide ? null :
                                <Grid item md={12} xs={12}>
                                    <table id="totalCrop">
                                        <thead>
                                            <tr>
                                                {contentRowNames.map((x, index) => {
                                                    let result = x.replace(/([A-Z])/g, " $1");
                                                    let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                                                    if (finalResult === "Collection Point Name") {
                                                        finalResult = "Route Name";
                                                    }
                                                    else if (finalResult === "Collection Point Code") {
                                                        finalResult = "RC";
                                                    }
                                                    else if (finalResult === "Collection Type Name") {
                                                        finalResult = "LT";
                                                    }
                                                    else if (finalResult === "Number Of Units") {
                                                        finalResult = "BC";
                                                    }
                                                    else if (finalResult === "Gross Amount") {
                                                        finalResult = "Gross/ kg";
                                                    }
                                                    else if (finalResult === "Total") {
                                                        finalResult = "TotDeduc";
                                                    }
                                                    return (
                                                        <th key={index}>{finalResult}</th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <RouteDeductionDetailsReportTable
                                                data={reportData}
                                                contentRowNames={contentRowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                        <tfoot>
                                        </tfoot>
                                    </table>
                                </Grid>
                            }
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Total Crop Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData} rowNames={contentRowNames}
                                            searchData={selectedSearchValues} totalRow={allTotal} columeNames={columeNames} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



